/* eslint no-console: "off" */

import Thrift, { TClientConstructor } from 'thrift';
import { TAuthenticationService } from 'TProtocol/authentication';
import { TBlastService } from 'TProtocol/blast';
import { TShareService } from 'TProtocol/share';
import { TContactsSyncService } from 'PProtocol/contactssync';
import { THomepageService } from 'TProtocol/homepage';
import { TWebService } from 'TProtocol/web';
import { TContactInfoService } from 'PProtocol/contactinfo';

declare const WEBSERVER_URL: string;
declare const WEBSERVER_PORT: number;
declare const WEBSERVER_HTTPS: boolean;

export default class Net {

  static createBlastService(): TBlastService.Client {
    return Net._createService(TBlastService, '/json/BlastService');
  }

  static createShareService(): TShareService.Client {
    return Net._createService(TShareService, '/json/ShareService');
  }

  static createContactsService(): TContactsSyncService.Client {
    return Net._createService(TContactsSyncService, '/json/ContactsSyncService');
  }

  static createContactInfoService(): TContactInfoService.Client {
    return Net._createService(TContactInfoService, '/json/ContactInfoService');
  }

  static createAuthService(): TAuthenticationService.Client {
    return Net._createService(TAuthenticationService, '/json/AuthenticationService');
  }

  static createHomepageService(): THomepageService.Client {
    return Net._createService(THomepageService, '/json/HomepageService');
  }

  static createWebService(): TWebService.Client {
    return Net._createService(TWebService, '/json/WebService');
  }

  static _createService<TClient>(service: TClientConstructor<TClient>, path: string): TClient {
    const transport = Thrift.TBufferedTransport;
    const protocol = Thrift.TJSONProtocol;
    const connection = Thrift.createXHRConnection(WEBSERVER_URL, WEBSERVER_PORT, {
      transport: transport,
      protocol: protocol,
      path: path,
      https: WEBSERVER_HTTPS
    });
    connection.on('Connection Error: ', () => console.log('Failed to create ' + path));
    return Thrift.createXHRClient(service, connection);
  }
}
